import React, { useEffect, useState } from 'react';
import './BankDetails.scss';
import plus from '../../../assets/image/plus.svg';
import Modal from '../../../component/modal/Modal';
import BankCard from '../BankCard';
import { useDispatch } from 'react-redux';
import { create_Vendor_bank, updateVendorBankDetails } from '../../../store/action/vendor';
import { toast } from 'react-toastify';
import { formatErrors } from '../../../utils/controller';
import { deleteBankDetails } from '../../../services/vendor';
import ConfirmationModal from '../../../component/modal/ConfirmationModal';
import AddBankDetails from '../AddBankDetails';

const BankDetails = ({ isEdit, data, error, setBankDetails, vendorId, reloadTable }) => {
	const [open, setOpen] = useState(false);
	const [bankIndex, setBankIndex] = useState(null);
	const dispatch = useDispatch();
	const [formError, setFormError] = useState({});
	const [isEditBankDetails, setIsEditBankDetails] = useState(false);
	const [formData, setFormData] = useState({
		bank_name: '',
		account_number: '',
		ifsc_code: '',
		beneficiary_name: '',
	});
	const selectedBank = bankIndex !== null ? data[bankIndex] : null;
	const [reaccount, setReaccount] = useState('');
	const [deleteBankDetailsId, setDeleteBankDetaislId] = useState(null);
	const [isDeleteBankDetailsModalOpen, setIsDeleteBankDetailsModalOpen] = useState(false);

	const openEditBankDetailsModal = (bankId) => {
		setIsEditBankDetails(true);
		setBankIndex(bankId);
		const bankDetails = data[bankId];
		setFormData(bankDetails);
		setReaccount(data[bankId].account_number);
		setOpen(true);
	};

	const handleInputChange = (key, value) => {
		const updatedData = { ...formData, [key]: value };
		setFormData(updatedData);

		if (value) {
			const newError = { ...error };
			delete newError?.[key];
			setFormError(newError);
		}
	};

	function validateFrom() {
		var errorForm = { ...formError };
		if (
			formData?.account_number === '' ||
			formData?.bank_name === '' ||
			formData?.beneficiary_name === '' ||
			formData?.ifsc_code === ''
		) {
			if (formData?.account_number === '') {
				errorForm.account_number = 'Account number is required!';
			}

			if (formData?.bank_name === '') {
				errorForm.bank_name = 'Bank name is required!';
			}

			if (formData?.beneficiary_name === '') {
				errorForm.beneficiary_name = 'Account holder name is required!';
			}

			if (formData?.ifsc_code === '') {
				errorForm.ifsc_code = 'IFSC Code is required!';
			}
			setFormError(errorForm);
			return;
		} else if (formData.account_number !== reaccount) {
			const newError = {
				...error,
				reaccount: 'Account numbers are not same',
			};
			setFormError(newError);
			return;
		} else {
			return true;
		}
	}

	const handleAddNewBankDetails = () => {
		if (!validateFrom()) return;

		if (vendorId) {
			dispatch(create_Vendor_bank(formData, vendorId)).then((res) => {
				if (res?.success) {
					toast.success(res?.message);
					setBankDetails([...(data || []), formData]);

					setFormData({
						bank_name: '',
						account_number: '',
						ifsc_code: '',
						beneficiary_name: '',
					});
					setReaccount('');
					setFormError({});
				} else {
					if (res?.code === 422) {
						let errorObj = formatErrors(res?.message);
						setFormError(errorObj);
					} else {
						toast.error(res?.message || 'Something went wrong');
					}
				}
			});
		} else {
			setBankDetails([...(data || []), formData]);
			setFormData({
				bank_name: '',
				account_number: '',
				ifsc_code: '',
				beneficiary_name: '',
			});
			setReaccount('');
		}

		setOpen(false);
	};

	const handleEditBankDetails = () => {
		if (!validateFrom()) return;

		if (vendorId) {
			dispatch(updateVendorBankDetails(vendorId, formData?.bank_details_id, formData))
				.then((res) => {
					if (res?.success) {
						toast.success(res?.message);

						setFormError({});
					} else {
						toast.error(res?.message || '');
					}
					setIsEditBankDetails(false);
				})
				.catch((err) => {
					setIsEditBankDetails(false);
					toast.error('Something went wrong!');
				});
		}

		const newBankDetails = data.map((bank, i) =>
			bankIndex === i ? { ...bank, ...formData } : { ...bank },
		);
		setBankDetails(newBankDetails);

		setFormData({
			bank_name: '',
			account_number: '',
			ifsc_code: '',
			beneficiary_name: '',
		});
		setReaccount('');
		setFormError({});
		setBankIndex(null);
		setOpen(false);
	};

	const handleDeleteBankDetails = async () => {
		if (vendorId) {
			try {
				const newBankDetails = data?.filter((_, i) => i !== deleteBankDetailsId);
				await deleteBankDetails(
					data[deleteBankDetailsId]?.vendor_id,
					data[deleteBankDetailsId]?.bank_details_id,
				);
				setBankDetails(newBankDetails);
				toast.success('Bank account deleted successfully!');
				setIsDeleteBankDetailsModalOpen(false);
			} catch (error) {
				toast.error('Something went wrong!');
			}
		} else {
			const newBankDetails = data?.filter((_, i) => i !== deleteBankDetailsId);
			setBankDetails(newBankDetails);
			toast.success('Bank account deleted successfully!');
			setIsDeleteBankDetailsModalOpen(false);
		}
	};

	useEffect(() => {
		if (selectedBank) {
			setFormData({ ...formData, ...selectedBank });
		}
	}, [selectedBank]);

	return (
		<div className="bankDetailsBody">
			<div
				className="headr"
				style={{
					padding: '0px 5px',
				}}
			>
				<p>Bank Accounts</p>
				<button
					type="button"
					className="w-100 btn btn-primary"
					style={{ paddingLeft: '9px', paddingRight: '9px' }}
					onClick={() => {
						setOpen(true);
					}}
				>
					<img
						src={plus}
						alt=""
					/>
				</button>
			</div>

			{data &&
				data.length > 0 &&
				data.map((bank, i) => (
					<React.Fragment key={i}>
						<BankCard
							id={i}
							data={bank}
							openEditBankDetailsModal={openEditBankDetailsModal}
							deleteBankDetails={(id) => {
								setDeleteBankDetaislId(id);
								setIsDeleteBankDetailsModalOpen(true);
							}}
						/>
					</React.Fragment>
				))}

			{/* Modal */}
			{open && (
				<Modal
					className="add-bank-detail-modal"
					isOpen={open}
					onClose={() => {
						setOpen(false);
						setFormData({ bank_name: '', account_number: '', ifsc_code: '', beneficiary_name: '' });
						setReaccount('');
						setFormError({});
						if (selectedBank) setBankIndex(null);
					}}
					title={<span style={{ fontWeight: '500', fontSize: '18px' }}>Add Bank Account</span>}
					handleSave={isEditBankDetails ? handleEditBankDetails : handleAddNewBankDetails}
					cancelButton={true}
					actionButton={true}
				>
					<AddBankDetails
						isEdit={!!selectedBank}
						reloadTable={reloadTable}
						setReaccount={setReaccount}
						formData={formData}
						reaccount={reaccount}
						setFormData={setFormData}
						error={formError}
						setError={setFormError}
						handleInputChange={handleInputChange}
					/>
				</Modal>
			)}

			{isDeleteBankDetailsModalOpen && (
				<ConfirmationModal
					isOpen={isDeleteBankDetailsModalOpen}
					title="Delete Bank Account"
					content={
						<p
							style={{
								textAlign: 'center',
								backgroundColor: '#E6F5FF',
								padding: '10px',
								borderRadius: '5px',
								fontWeight: '500',
								color: 'black',
							}}
						>
							Are you sure you want to delete this bank account?
						</p>
					}
					onCancel={() => {
						setIsDeleteBankDetailsModalOpen(false);
						setReaccount('');
						setDeleteBankDetaislId(null);
					}}
					onOk={handleDeleteBankDetails}
				/>
			)}
		</div>
	);
};

export default BankDetails;
